export default __webpack_public_path__ + "static/9_30-36c8b57b559a73c1b4485b5205787c0e.png";